module.exports = __webpack_public_path__ + "static/img/K_hearts.7784106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/K_hearts.svg
// module id = Z07K
// module chunks = 1